import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isExtraInfoOrMeta } from 'emergency_data/src/components/JurisdictionView/helpers';
import { getMostRecentLoc } from 'emergency_data/src/utils/getMostRecentLoc';
import { createSelector } from 'reselect';
import { trackCTMAcceptedCall } from '@rsos/components/capstone/Layout/Navigation/RSP/SettingsControl/CallTakerMode/ctmTracking';
import { setSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import usePrevious from '@rsos/utils/usePrevious';

export default function useCallTakerMode(
  filteredCalls,
  hasCTMPermission,
  numberWithNewLocation,
  selectedCallerID,
  irpVersion,
) {
  const dispatch = useDispatch();
  const prevNumberWithNewLocation = usePrevious(numberWithNewLocation);

  const user = createSelector(
    state => state.sinatra.user,
    user => user,
  );
  const { currentRole, profile } = useSelector(user);
  const applicationName = currentRole.application;

  const isCallTakerModeOn = useMemo(() => {
    return profile?.attributes?.[applicationName]?.call_taker_mode_settings
      ?.is_enabled;
  }, [profile]);

  const workstationPosition = useMemo(() => {
    return profile?.attributes?.[applicationName]?.call_taker_mode_settings
      ?.workstation_position;
  }, [profile]);

  // cannot immediately use numberWithNewLocation because the map is still looking at isAllView
  if (
    !numberWithNewLocation &&
    prevNumberWithNewLocation &&
    !selectedCallerID
  ) {
    const mostRecentLoc = getMostRecentLoc(
      filteredCalls[prevNumberWithNewLocation],
    );

    const mostRecentWorkstationPosition =
      filteredCalls[prevNumberWithNewLocation] &&
      filteredCalls[prevNumberWithNewLocation].workstationPositions &&
      filteredCalls[prevNumberWithNewLocation].workstationPositions.length &&
      filteredCalls[prevNumberWithNewLocation].workstationPositions[
        filteredCalls[prevNumberWithNewLocation].workstationPositions.length - 1
      ];

    const shouldOpenCTM =
      hasCTMPermission &&
      isCallTakerModeOn &&
      mostRecentLoc.class_of_service_category &&
      mostRecentWorkstationPosition === workstationPosition;

    if (shouldOpenCTM) {
      const { payloadID, requestID } = isExtraInfoOrMeta(mostRecentLoc);

      trackCTMAcceptedCall(
        workstationPosition,
        irpVersion,
        payloadID,
        requestID,
      );
      dispatch(setSelectedCallerID(mostRecentLoc.caller_id));
    }
  }
}
